import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router, RouterLink, RouterLinkActive, RouterModule } from '@angular/router';
export interface SubMenu {
  display: string;
  router: string | null;
  icon?: string;
  isOpen?: boolean;
  subMenu?: null | SubMenu[];
  isOpenRoute?: string;
}
export interface Menu {
  display: string;
  router: string | null;
  icon: string;
  isOpen?: boolean;
  subMenu?: null | SubMenu[];
  isOpenRoute?: string;
}

@Component({
  selector: 'app-sidebar',
  imports: [RouterLink, RouterLinkActive, CommonModule],
  templateUrl: './sidebar.html',
  styleUrl: './sidebar.scss',
})
export class SidebarComponent implements OnInit {
  public menuConfig: Menu[];
  env = 'dev';
  constructor(private readonly router: Router) {
    this.menuConfig = [
      {
        display: 'Home',
        router: '/home',
        icon: 'home',
        subMenu: null,
      },
      {
        display: 'Operations',
        router: '/operations',
        icon: 'operations',
        subMenu: null,
      },
      {
        display: 'Reference data',
        icon: 'reference',
        router: null,
        isOpenRoute: 'reference-data',
        isOpen: false,
        subMenu: [
          {
            display: 'Instruments',
            router: '/reference-data/instruments',
          },
          {
            display: 'Currencies',
            router: '/reference-data/currencies',
          },
          {
            display: 'FX calendar',
            router: '/reference-data/fx-calendar',
          },
        ],
      },
      {
        display: 'Settings',
        icon: 'settings',
        router: null,
        isOpenRoute: 'settings',
        isOpen: false,
        subMenu: [
          // {
          //   display: 'Accounts',
          //   router: '/settings/accounts',
          // },
          // {
          //   display: 'Market data fabric',
          //   router: '/settings/market-data',
          // },
          {
            display: 'Users',
            router: '/settings/users',
          },
        ],
      },
    ];
  }

  ngOnInit() {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.menuConfig.map((item) => {
          if (item.isOpenRoute) {
            item.isOpen = event.url.includes(item.isOpenRoute);
          }
          if (item.subMenu?.length) {
            item.subMenu.map((item) => {
              return item.isOpenRoute ? (item.isOpen = event.url.includes(item.isOpenRoute)) : item;
            });
          }
          return item;
        });
      }
    });
  }
}
